<template>
  <div class="diadin">
    <div style="display: flex;">
      <el-input  style="width: 300px;margin-right: 10px;" clearable v-model="acss" :placeholder="$t('menu.chejiahao')" ></el-input>
         <el-button type="primary" @click="searchac()" >{{ $t('menu.search') }}</el-button>
    </div>
    <div class="title">
      <div class="title_1">{{$t('menu.Basicinformation')}}</div>
      <!-- <div>
        <el-button @click="handleEdit">返回</el-button>
      </div> -->
    </div>
    <div class="cont">
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.VehicleName') }}</div>
        <div>{{ filterCarModels(carInfo.mcSeriesModel) }}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Colour') }}</div>
        <div>{{carInfo.vehicleColor}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.State') }}</div>
        <div>{{  carInfo.status == 'Registered' ? $t('menu.Registered') : $t('menu.Unregistered')}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.FrameNumber') }}</div>
        <div>{{carInfo.chassisNumber}}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.EngineNumber') }}</div>
        <div>{{carInfo.engineNumber}}</div>
      </div>
      <!-- <div class="contbox">
        <div class="conttitle">{{ $t('menu.Distributor') }}</div>
        <div>{{carInfo.dealerId}}</div>
      </div> -->
      <!-- <div class="contbox">
        <div class="conttitle">{{ $t('menu.DeliveryDate') }}</div>
        <div>{{(carInfo.entryDate != null && carInfo.entryDate !='') ?carInfo.entryDate.split(' ')[0] : carInfo.entryDate }}</div>
      </div> -->
      <div class="contbox">
        <div class="conttitle">{{$t('menu.Distributor') }}</div>
        <div>{{carInfo.retailerName  }}</div>
      </div>
      
    </div>
    <div class="title" style="margin-bottom: 20px;justify-content: left;">
      <div class="title_1" style="cursor: pointer; margin-right: 25px;" :class="(action == $t('menu.CustomerInformation') && type != 1) ? 'actio' : ''" @click="act($t('menu.CustomerInformation'))">
        {{$t('menu.CustomerInformation') }}
      </div>
     
    </div>
    <div v-if="action == $t('menu.CustomerInformation')" class="customerINfo">
       <!-- 客户的信息 -->
      <!-- <div class="boxOne">
        <div class="label"><span style="color: red;" >*</span> {{$t('menu.CustomerName')}}</div>
        <el-input v-model="carInfo.customerName" :placeholder="$t('menu.Enter')" ></el-input>
       
      </div> -->
      <div class="boxOne">
        <div class="label"><span style="color: red;">*</span> {{ $t('menu.CustomerType') }}</div>
        <el-select v-model="carInfo.customerType" :placeholder="$t('menu.CustomerType')">
          <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,index) in titleList" :key="index"></el-option>
        </el-select>
       
      </div>
      <div class="boxOne">
        <div class="label"><span style="color: red;" >*</span>  {{ $t('menu.SaleDate') }}</div>
        <el-date-picker type="date" :placeholder="$t('menu.Expected')" v-model="carInfo.salesDate" value-format="yyyy-MM-dd" style="width: 91%" ></el-date-picker>
      
      </div>
      <!-- <div class="boxOne">
        <div class="label">  {{ $t('menu.licensePlateNumber') }}</div>
        <el-input v-model="carInfo.licensePlate" :placeholder="$t('menu.Enter')"></el-input>
       
      </div>
      <div class="boxOne">
        <div class="label">  {{ $t('menu.contactNumber') }}</div>
        <el-input v-model="carInfo.customerPhone" :placeholder="$t('menu.Enter')" ></el-input>
       
      </div>
      <div class="boxOne">
        <div class="label">  {{ $t('menu.EmailAddress') }}</div>
        <el-input v-model="carInfo.customerEmail" :placeholder="$t('menu.Enter')" ></el-input>
        
      </div>
      <div class="boxTwo">
        <div class="label">{{ $t('menu.Address') }}</div>
        <el-input v-model="carInfo.customerAddress" :placeholder="$t('menu.Enter')" ></el-input>
        
      </div> -->
      <div class="boxTwo">
        <div class="label">{{ $t('menu.PictureMaterials') }}</div>
        <el-upload action="#" class="upload-demo" :http-request="uploadFile" :show-file-list="false" >
          <el-button size="small" plain>{{$t('menu.Uploadfiles')}}</el-button>
        </el-upload>
        <div class="demo-image__preview">
          <div class="im" v-for="(item,index) in imgsrcList" :key="index">
            <el-image :src="item" :preview-src-list="imgsrcList" class="imgBox"></el-image> 
            <i class="el-icon-circle-close iconB" @click="deleteImg(item)"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="action == $t('menu.ClaimRecord')">
      <el-table :data="mation" style="width: 100%" stripe border highlight-current-row>
        <el-table-column prop="cl" :label="$t('menu.ClaimNumber')" width="180"></el-table-column>
          <el-table-column prop="cjh" :label="$t('menu.Vehicle')" width="180"> </el-table-column>
          <el-table-column prop="vin" :label="$t('menu.ClaimType')"></el-table-column>
          <el-table-column prop="xsd" :label="$t('menu.Mileage2')" width="130"></el-table-column>
          <el-table-column prop="zt" :label="$t('menu.Currency')" width="150">
          <template slot-scope="scope">
            {{ scope.row.zt | sellstatus }}
          </template>
        </el-table-column>
        <el-table-column prop="rk" :label="$t('menu.ClaimAmount')" width="150"></el-table-column>
        <el-table-column prop="xs" :label="$t('menu.ApplicationTime')"></el-table-column>
      </el-table>
    </div>
    <div v-if="action == $t('menu.OperationRecord')">
      <el-table :data="mation" style="width: 100%" stripe border highlight-current-row>
        <el-table-column prop="cl" :label="$t('menu.Timecaozuo')" width="180"></el-table-column>
        <el-table-column prop="cjh" :label="$t('menu.Operator')" width="180"> </el-table-column>
        <el-table-column prop="vin" :label="$t('menu.OperationContent')"></el-table-column>
        <el-table-column prop="xsd" :label="$t('menu.Remarks')" width="130"></el-table-column>
      </el-table>
    </div>
    <div>
     
      <el-button type="primary" @click="submitForm()" >{{ $t('menu.Save') }}</el-button>
     
      <el-button @click="resetForm()" >{{ $t('menu.Cancel') }}</el-button>
    </div>
  </div>
</template>
    
<script>
import { mcVehicleOfDealerInfo,upload,listMcSeriesModels,changemcVehicleOfDealer,aaddmcVehicleOfDealer,querytype,mcVehicleOfDealerLista } from "../../api/api";

export default {
  data() {
    return {
      action: this.$t('menu.CustomerInformation'),
      type:1,  //1-注册  2-展示  3-修改
      acss:'',
      mation:[],
      id:null,
      input:'',
      carInfo:{},
      imgsrcList: [],
      cartypelist:[],
      iszh:sessionStorage.getItem('i18n'),
      titleList:[],
    };
  },
  mounted() {
    this.getQuerytype()
    // this.id=this.$route.query.id
    // this.type =1
    // this.mcVehicleOfDealerInfo()
    this.listMcSeriesModel()
  },
  methods: {
    searchac(){
      if(this.acss==''){
        return false
      }
       let params = 'searchValue=' + this.acss
       mcVehicleOfDealerLista(params).then(res=>{
        this.carInfo = res.data.rows[0]
        this.carInfo.salesDate = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' +  String(new Date().getDate()).padStart(2, '0');
        if( this.carInfo.customerMaterials!='') this.imgsrcList = this.carInfo.customerMaterials.split(',')
      })

    },
    //获取车辆详细信息
    mcVehicleOfDealerInfo(){
      mcVehicleOfDealerInfo(this.id).then(res=>{
        this.carInfo = res.data.data
        this.carInfo.salesDate = new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' +  String(new Date().getDate()).padStart(2, '0');
        if( this.carInfo.customerMaterials!='') this.imgsrcList = this.carInfo.customerMaterials.split(',')
      })
    },
    //获取车型
    async listMcSeriesModel () {
      // let param = new URLSearchParams();
      // const { data: res } = await listMcSeriesModels(param);
      // this.cartypelist = res.data;
      const params = new URLSearchParams()
      querytype( params, 't_mc_series_model').then(r => {
        console.log(r);
        this.cartypelist = r.data.data;
        // if (r.data.code == 200) {
        //   r.data.data.forEach(i => {
        //     if (this.iszh !== 'zh') {
        //       i.dictLabel = i.dictLabelEn
        //     }
        //     this.titleList.push(i)
        //   })
        // }
      })
    },
    filterCarModels(m){
      if(this.cartypelist.some(e=>e.dictValue == m)){
        return this.cartypelist.filter(e=>e.dictValue == m)[0].dictLabel
      } else {
        return m
      }
    }, 
    submitForm() {
      this.carInfo.status = 'Registered'
      let a = ''
      this.imgsrcList.forEach(e=>{
        if(a == ''){
          a = a + e
        } else {
          a = a + ',' + e
        }
      })
     
      this.carInfo.customerMaterials = a 
      let data= this.carInfo
      data.salesDate=this.carInfo.salesDate+' 00:00:00'
      data.status='Registered'
      changemcVehicleOfDealer(data).then(res=>{
        if(res.data.code == 200){
          this.$message.success(res.data.msg)
          this.$router.push('/sell')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    editForm(){
      let a = ''
      this.imgsrcList.forEach(e=>{
        if(a == ''){
          a = a + e
        } else {
          a = a + ',' + e
        }
      })
      this.carInfo.customerMaterials = a 
      
      let data= this.carInfo
      if(data.salesDate.length<11){
         data.salesDate=this.carInfo.salesDate+' 00:00:00'
       }
      changemcVehicleOfDealer(data).then(res=>{
        if(res.data.code == 200){
          this.$message.success(res.data.msg)
          this.$router.push('/sell')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    edit(){
      this.type = 3
    },
    resetForm() {
      this.$router.push('/sell')
    },
    act(e){
      this.action = e
    },
    uploadFile(file){
      let formdata = new FormData()
      formdata.append('file',file.file)
      formdata.append('category',file.file.type)
      upload(formdata).then(res=>{
        if(res.data.code == '200'){
          this.$message.success('上传成功')
          this.imgsrcList.push(res.data.data)
        } else {
          this.$message.error('上传失败')
        }
      })
    },
    deleteImg(e){
      this.imgsrcList = this.imgsrcList.filter(m=>m != e)
    },
    handleEdit(index, row) {
      this.$router.push({
        path: "/sell",
        query: {
        },
      });
    },
    getQuerytype () {
      const params = new URLSearchParams()
      querytype( params, 't_mc_vehicle_customer_type').then(r => {
        if (r.data.code == 200) {
          r.data.data.forEach(i => {
            if (this.iszh !== 'zh') {
              i.dictLabel = i.dictLabelEn
            }
            this.titleList.push(i)
          })
        }
      })
    },
    checkcurtype(e){
      return this.titleList.filter(m=>m.dictValue == e).length> 0 ? this.titleList.filter(m=>m.dictValue == e)[0].dictLabel : e
    },
  },
};
</script>
    
<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  .title {
    width: 100%;
    border-bottom: 1px solid #f2f2f2;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title_1 {
      padding-left: 15px;
      border-left: 5px solid #409eff;
    }
  }
  .cont {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 10px;
    .contbox {
      width: 30%;
      text-align: left;
      margin: 10px 0;
      .conttitle {
        width: 180px;
        padding: 15px 0;
      }
    }
  }
  .customerINfo{
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .boxOne{
      width: 30%;
      margin: 10px 0;
      .label{
        padding-bottom: 10px;
      }
    }
    .boxTwo{
      width: 100%;
      margin: 10px 0;
      .label{
        padding-bottom: 10px;
      }
      .demo-image__preview{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .im{
          position: relative;
          .imgBox{
            margin: 10px;
            width: 200px;
            height: 100px;
          }
          .iconB{
            position: absolute;
            color: red;
            top: 0px;
            right: 0px;
            cursor: pointer;
            font-size: 24px;
          }
        }
        
      }
    }
  }
}
/deep/.el-form-item__content {
  width: 100%;
}
/deep/.el-select {
  width: 95%;
}
/deep/.el-table th.is-leaf{
    text-align: center;
    background-color: #d7d7d7;
}
.actio{
  color: #409eff;
}
</style>